import * as React from 'react'
import { Navigate } from 'react-router-dom'
import { useLogOut } from '@user/store/authorization/hooks'

export const Unknown: React.FC = () => {
  const logout = useLogOut()

  React.useEffect(() => {
    logout()
  }, [logout])

  return <Navigate to="/" replace />
}
